export const NON_CACHED_ROUTES_REGEX_WHITELIST = [/^\/s\/*/];
//# sourceMappingURL=constants.js.map